"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var components_1 = require("@athena-portal/components");
var Notification_1 = require("../../Notification");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../../Types");
var SupportPortalTemplates_1 = require("../../../SupportPortalTemplates");
var operators_1 = require("rxjs/operators");
var ShowLoginActivitiesAction = /** @class */ (function (_super) {
    __extends(ShowLoginActivitiesAction, _super);
    function ShowLoginActivitiesAction(props) {
        var _this = _super.call(this, props) || this;
        _this.renderUserEventsTableRows = function (userEvents) {
            return userEvents.map(function (userEvent, index) { return ((0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsx)("td", { children: SupportPortalTemplates_1.SupportPortalTemplates.convertDateToUkTimeZoneDate(userEvent.time) }), (0, jsx_runtime_1.jsx)("td", { children: userEvent.type }), (0, jsx_runtime_1.jsx)("td", { children: userEvent.ipAddress }), (0, jsx_runtime_1.jsx)("td", { children: userEvent.error }), (0, jsx_runtime_1.jsx)("td", { children: userEvent.details &&
                            Object.entries(userEvent.details).map(function (_a) {
                                var key = _a[0], value = _a[1];
                                return ((0, jsx_runtime_1.jsxs)("li", { children: [key, ": ", value] }, key));
                            }) })] }, index)); });
        };
        _this.toggleLoginActivitiesModal = function () {
            if (!_this.state.activitiesLoaded) {
                _this.getData();
            }
            _this.setState(function (prevState) { return ({
                showLoginActivities: !prevState.showLoginActivities
            }); });
        };
        _this.state = {
            showLoginActivities: false,
            activitiesLoaded: false
        };
        return _this;
    }
    ShowLoginActivitiesAction.prototype.getData = function () {
        var _this = this;
        if (this.props.customerId) {
            this.supportPortalService
                .getUserEvents(this.props.customerId)
                .pipe((0, operators_1.finalize)(function () { return _this.setState({ activitiesLoaded: true }); })).subscribe(function (userEvents) {
                _this.setState({ userEvents: userEvents });
            });
        }
    };
    ShowLoginActivitiesAction.prototype.render = function () {
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("a", { className: "d-block text-primary on-hover-underline", onClick: this.toggleLoginActivitiesModal, children: "Login activities log" }), (0, jsx_runtime_1.jsx)(Notification_1.default, { show: this.state.showLoginActivities, hide: this.toggleLoginActivitiesModal, title: "Login activities log", body: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(components_1.Overlay, { show: !this.state.activitiesLoaded }), this.state.activitiesLoaded &&
                                (this.state.userEvents !== undefined ? ((0, jsx_runtime_1.jsxs)("table", { className: "table table-hover table-sm table-bordered", children: [(0, jsx_runtime_1.jsx)("thead", { children: (0, jsx_runtime_1.jsxs)("tr", { className: "table-active", children: [(0, jsx_runtime_1.jsx)("th", { children: "Date:" }), (0, jsx_runtime_1.jsx)("th", { children: "Type:" }), (0, jsx_runtime_1.jsx)("th", { children: "IP Address:" }), (0, jsx_runtime_1.jsx)("th", { children: "Error:" }), (0, jsx_runtime_1.jsx)("th", { children: "Details:" })] }) }), (0, jsx_runtime_1.jsx)("tbody", { children: this.renderUserEventsTableRows(this.state.userEvents) })] })) : (0, jsx_runtime_1.jsx)("h4", { children: "Login Activities not found" }))] }), style: {
                        margin: "0",
                        maxWidth: "100%",
                        width: "100%"
                    } })] }));
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], ShowLoginActivitiesAction.prototype, "supportPortalService", void 0);
    ShowLoginActivitiesAction = __decorate([
        components_1.authorize,
        (0, components_1.role)("Administrator", "Fraud", "Support", "CSR_Lead", "CSR", "Read_Only"),
        __metadata("design:paramtypes", [Object])
    ], ShowLoginActivitiesAction);
    return ShowLoginActivitiesAction;
}(React.Component));
exports.default = ShowLoginActivitiesAction;
//# sourceMappingURL=ShowLoginActivitiesAction.js.map